import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Footer from 'components/Footer/Footer';
//import './style.css';
//import PKimg from 'Assets/pksuccess.svg';
//import { Container, Row, Col } from 'react-bootstrap';
//import Button from "components/Button/Button";
//import Table from 'react-bootstrap/Table';
import { owner_perms, user_access_level, org_friendly_url } from "Api/Api";
// , user_entity_uuid, user_API, user_Status, user_Status_Ver, presentation_Creation_API, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control, organization_user_access_level, user_account_level, apiUrl, searchUrl, org_name
// import axios from "axios";
//import { getKey, dateConvert, unixDateConversion,origin, current_unix_stamp } from 'utils/Helper';
// import { getKey, dateConvert, unixDateConversion, get_current_unix_stamp } from 'utils/Helper';
//import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
//import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
//import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
//import PkList from 'components/PkListTable/PkList';
//import PkListTable from 'components/PkListTable/PkListTable';
//import PkListTableV2 from 'components/PkListTable/PkListTableV2';
import AgoraVideoChatControlComponent from 'components/VideoChat/AgoraVideoChatControlComponent';
import { withRouter, Redirect } from "react-router-dom";
//import TableHeader from 'components/Table/TableHeaderV2';
import home from 'Assets/home.svg';
import { local_routes } from 'utils/Routes';

class VideoChatControl extends Component {
    constructor(props) {
        super(props)
        this.state = {
          incall_flag: false,
          allowed: true
        };
        
        this.workspace_base_url = "";
        //this.workspace_indicator = '';
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
          //this.workspace_indicator = <span data-tip="Want to create public presentations? Switch to Public View in upper right" style={{ verticalAlign: 'text-top', fontSize: "small" }} >&nbsp;&bull;&nbsp;{org_name} View</span>;
        } else {
            if (user_access_level === 'admin' || owner_perms.organizations) {
                //this.workspace_indicator = <span data-tip="Want to create private presentations? Switch to Team View in upper right" style={{ verticalAlign: 'text-top', fontSize: "small" }} >&nbsp;&bull;&nbsp;Public View</span>;
            }
        } 
        
        //this.auto_refresh_time = 30; // seconds
        
        //this.interval = setInterval(() => this.setState({ time: Date.now() }), 5000);
    }

    // Api Integration Strats here
    componentDidMount() {
      console.log("VideoChats componentDidMount");
  
      if (user_access_level !== 'admin') {
        this.setState({
          allowed: false
        });
        return;
      }
    }

    inCallCallback = (incall_flag) => {
      console.log("inCallCallback",incall_flag);
      this.setState({
        incall_flag
      });
    }

    render() {
      if (!this.state.allowed) {
        return (
          <Redirect to="/404" />
        );
      }

      return (
          <React.Fragment>
            <Helmet defer={false}>
                <title>PechaKucha Chats</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <React.Fragment>
              <div>
                <AgoraVideoChatControlComponent
                  inCallCallback={this.inCallCallback}
                />
                {!this.state.incall_flag &&
                <div style={{display:'block'}} className="myPkFooter">
                  <Footer
                    homeImg={home}
                    homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
                    breadcrumbSubPage="My Video Chats"
                  />
                </div>
                }
              </div>
            </React.Fragment>
          </React.Fragment>
        );

    }
}

export default withRouter(VideoChatControl);